<script>
import { mapActions, mapGetters } from 'vuex';

import FirstForm from '@/modules/first-form/FirstForm.vue';
import FirstFormNewBg from '@/modules/first-form/FirstFormNewBg.vue';
import InlineForm from '@/modules/first-form/InlineForm.vue';
import FormDetails from '@/modules/form-details/FormDetails.vue';
import InvoiceSummary from '@/modules/invoice-summary/InvoiceSummary';
import {PAYMENT_TYPES} from "@/modules/constants";
import SelectionPopup from '@/components/selection-popup/SelectionPopup.vue';

export default {
  name: 'FormController',
  components: { InvoiceSummary, FormDetails, FirstForm, FirstFormNewBg, InlineForm, SelectionPopup },
  computed: {
    ...mapGetters(['step', 'inlineForm', 'fromUrl', 'newLpForm'])
  },
  methods: {
    ...mapActions([
      'setIsMobileAction',
      'resetStoreAction',
      'setIsFormDetailsEditAction',
      'getPriceInfoAction',
      'getTotalPriceAction',
      'getCustomerAction',
      'getReasonsAction',
      'getBranchesAction'
    ])
  },
  async beforeMount() {
    this.$store.commit('SET_SELECTION_POPUP', false);
    this.$store.commit('SET_SELECTION_POPUP_ITEMS', []);
    this.$store.commit('SET_SELECTION_POPUP_LEVEL', 1);

    let urlParams = new URLSearchParams(window.location.search);

    // If variant (iframe variant) reset on page-load
    if (urlParams.has('variant')) {
      await this.resetStoreAction();
    }else {
      // get customer if logged-in
      await this.getCustomerAction();
    }

    if (document.location.href.indexOf('?new') > -1) {
      await this.resetStoreAction();
      window.location.href = 'index.html';
    }

    this.setIsMobileAction();

    if (this.step === 1) {
      if (urlParams.has('plz') && urlParams.has('dateFrom') && urlParams.has('dateTo') && urlParams.has('length') && urlParams.has('reason')) {
        if (urlParams.has('zipId') && urlParams.has('zipLevel')) {
          this.$store.commit('SET_SELECTION_POPUP_ZIPID', urlParams.get('zipId'));
          this.$store.commit('SET_SELECTION_POPUP_LEVEL', urlParams.get('zipLevel'));
        }
        this.$store.commit('SET_FROM_URL', urlParams.get('fromUrl'));
        this.$store.commit('SET_FORM_DATA', {
          zipCode: urlParams.get('plz'),
          reason: urlParams.get('reason'),
          length: urlParams.get('length'),
          dateFrom: urlParams.get('dateFrom'),
          dateTo: urlParams.get('dateTo'),
        });
        await this.getPriceInfoAction({zipcode: urlParams.get('plz'), priceForSecondForm: false});

        this.setIsFormDetailsEditAction(false);
        await this.getTotalPriceAction();
        this.$store.commit('SET_NEXT_STEP', 2);
      }

      if (this.fromUrl == '') {
        let fromUrlToSave = window.location.href;
        if (fromUrlToSave.includes('?new')) {
          fromUrlToSave = fromUrlToSave.replace('?new', '');
        }
        this.$store.commit('SET_FROM_URL', fromUrlToSave);
      }
    }

    // get all reasons
    await this.getReasonsAction();

    // get all branches
    await this.getBranchesAction();
  },
  mounted() {
    // inline-form is used for subpages with layout "preise.phtml"
    this.$store.commit('SET_INLINE_FORM', false);
    if (this.$el.parentElement.classList.contains('inline-form') || this.$el.parentElement.classList.contains('inline-form1')) {
      this.$store.commit('SET_INLINE_FORM', true);
    }

    // new-lp-form is used for landingpages with new bg
    this.$store.commit('SET_NEW_LP_FORM', false);
    if (this.$el.parentElement.classList.contains('new-lp-form')) {
      this.$store.commit('SET_NEW_LP_FORM', true);
    }
  }
};
</script>
<template>
  <div>
    <selection-popup pop-up-headline="Bitte wählen Sie den Ort aus" />

    <div v-if="inlineForm === true">
      <inline-form />
    </div>
    <div v-else>
      <div v-if="step === 1">
        <div v-if="newLpForm === true">
          <first-form-new-bg />
        </div>
        <div v-else>
          <first-form />
        </div>
      </div>
      <div v-else-if="step === 2">
        <form-details />
      </div>
      <div v-else-if="step === 3">
        <invoice-summary />
      </div>
      <div v-else>
        <first-form />
      </div>
    </div>
  </div>
</template>
<style></style>
